import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true, state: {
        listing: [],
        similar_listings: {},
        listings: {data: [], current_page: 1, total: 0, per_page: 10},
        loading: false,
        errors: {
            data: {
                errors: {
                    property_id: [],
                    name: [],
                    property_type_id: [],
                    county_id: [],
                    local_area: [],
                    baths: [],
                    phone: [],
                    date: []
                }
            }
        },
        has_errors: false,
    }, getters: {
        loading: state => state.loading,
        listing: state => state.listing,
        listings: state => state.listings,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        similar_listings: state => state.similar_listings,
    }, mutations: {
        setSimilarListings(state, data) {
            state.similar_listings = data;
        },
        setLoading(state, val) {
            state.loading = val
        }, setListings(state, data) {
            state.listings = data;
        }, setListing(state, data) {
            state.listing = data;
        }, setErrors(state, errors) {
            state.errors = errors
        }, hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            property_id: [], name: [],
                        }
                    }
                };
            }
        }
    }, actions: {
        async getSimilarListings({commit}, filters) {
            try {
                commit('activateLoading', 'property/list', {root: true});
                const response = await api.getSimilarListings(filters);
                commit('setSimilarListings', response);
                commit('deactivateLoading', 'property/list', {root: true});
            } catch (e) {
                // ElMessage.error(e.response.data.message);
            }
        },
        async getListing({commit}, listing_id) {
            try {
                const response = await api.getListing(listing_id);
                commit('setListing', response.data)
            } catch (e) {
                ElMessage.error("")
            }
        },

        async getListings({commit}, filters) {
            try {
                commit('activateLoading', 'listing/list', {root: true});
                const response = await api.getListings(filters);
                commit('setListings', response);
                commit('deactivateLoading', 'listing/list', {root: true});
            } catch (e) {
                console.log(e)
                ElMessage.error({
                    "message": "There was a problem fetching units for this property."
                })
            }
        },

        async getUserListings({commit}, filters) {
            try {
                commit('activateLoading', 'listing/list', {root: true});
                const response = await api.getUserListings(filters);
                commit('setListings', response);
                commit('deactivateLoading', 'listing/list', {root: true});
            } catch (e) {
                console.log(e)
                ElMessage.error({
                    "message": "There was a problem fetching units for this property."
                })
            }
        },

        async createListings({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.createListing(data);
                ElMessage.success({
                    message: "Added unit successfully!",
                    offset: 100
                })
                commit('setLoading', false)
                window.location.href = "/my-listings"
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "Error adding unit!",
                    offset: 100
                })
                commit('setLoading', false)
            }
        }, async editListing({dispatch, commit}, data) {
            try {
                commit('setLoading', true);
                await api.editListing(data);
                ElMessage.success({
                    message: "Information updated successfully.",
                    offset: 100
                })
                commit('setLoading', false);
                window.location.href = "/my-listings"
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: "Error updating unit!",
                    offset: 100
                })
            }
        },

        async updateListingViews({commit}, id) {
            try {
                commit('activateLoading', 'property/list', {root: true});
                const response = await api.updateListingViews(id);
                commit('deactivateLoading', 'property/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async book({commit}, id) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                commit('activateLoading', 'property/list', {root: true});
                const response = await api.book(id);
                ElMessage.success({
                    message: response?.message,
                    offset: 100
                })
                commit('deactivateLoading', 'property/list', {root: true});
                commit('setLoading', false)

            } catch (e) {
                commit('hasErrors', true)
                commit('setLoading', false)
                commit('setErrors', e.response)
                ElMessage.error({
                    message: e.response.data.message,
                    offset: 100
                })
            }
        },

        async deleteListing({dispatch, commit}, unit) {
            try {
                commit('setLoading', true)
                await api.deleteListing(unit)
                dispatch('getListings', {
                    paginate: true,
                    property_id: unit.property_id
                });
                ElMessage.success('Information removed successfully.');
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error removing Listing Unit');
            }
        }

    }
}
